import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { RiVipCrownFill } from "react-icons/ri";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { FcCalendar } from "react-icons/fc";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { partenaireData } from "../../../json/partenairesData";
import { useRef } from "react";
import crown from "../../../assets/images/GTM-APP-icons/gold_crown.png";
import { FaLocationDot } from "react-icons/fa6";
import { MdCalendarMonth } from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function WelcomeScreen() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const defaultColor = useSelector((state) => state.gtm.defaultColor);
  const [user, setUser] = useState();
  const [member, setMember] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [pack, setPack] = useState(null);
  const [events, setEvents] = useState(null);
  const [finishedEvents, setFinishedEvents] = useState(null);
  const [thisMonthEvents, setThisMonthEvents] = useState(null);
  const [isEventsLoading, setIsEventsLoading] = useState(true);
  const [isGolfer, setIsGolfer] = useState(null);
  const navigate = useNavigate();
  const [membership, setMembership] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [pasteShowAll, setPasteShowAll] = useState(false);
  const [discounts, setDiscounts] = useState([]);

  const prevRef = useRef();
  const nextRef = useRef();
  const [swiperInstance, setSwiperInstance] = useState();


  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  const fetchData = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(response.data);
        setMembership(response.data?.membership);
        setIsGolfer(response.data.golfeurs);
        console.log(`is the user a golfer: ${response.data.golfeurs}`);

        if (response.data?.membership?.status === "valid") {
          setMember(response.data.membership);
          setPack(response.data.membership?.membership_packs);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  const fetchEvents = useCallback(async () => {
    try {
      const res = await axios.get(`${baseUrl}/events`);
      const today = new Date();
      const currentDate = today.toISOString().split("T")[0];
      const currentMonth = currentDate.split("-")[1];
      const yetToCome = res.data.events.filter(
        (event) => event?.date >= currentDate
      );
      const happened = res.data.events
        .filter((event) => event?.date < currentDate)
        .sort((a, b) => new Date(b.date) - new Date(a.date));
      const thisMonth = res.data.events.filter(
        (event) =>
          event?.date >= currentDate &&
          event?.date.split("-")[1] == currentMonth
      );
      setEvents(yetToCome);
      setFinishedEvents(happened);
      setThisMonthEvents(thisMonth);
    } catch (error) {
      console.log(error);
    } finally {
      setIsEventsLoading(false);
      console.log("events fetched");
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchData();
    fetchEvents();

    return () => {
      setUser(null);
      setIsGolfer(null);
      setMember(null);
      setPack(null);
      setEvents(null);
      setIsEventsLoading(true);
      setIsLoading(true);
    };
  }, [fetchData, fetchEvents]);

  useEffect(() => {
    console.log(`isGolfer value == ${isGolfer}`);
    console.log(`user.golfeurs == ${user?.golfeurs}`);
    console.log(`user.membership == ${user?.membership}`);
  }, [isGolfer, user]);

  const handleEventClick = (item) => {
    console.log(`Passing isGolfer: ${user?.golfeurs}`);
    console.log(`Passing membership: ${user?.membership}`);
    console.log(`Passing memberId: ${member?.id}`);
    navigate("/membership/show_events", {
      state: {
        isGolfer: user?.golfeurs,
        eventId: item.id,
        pack: pack?.name,
        memberId: member?.id,
        membershipId: member?.membership_id,
      },
    });
  };

  const fetchDiscounts = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/discounts`);
      setDiscounts(response.data.discounts || []);
    } catch (error) {
      console.error("Failed to fetch discounts:", error);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchDiscounts();
  }, [fetchDiscounts]);

  const getimagess = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.background}`;
    }

    return "#608D40";
  };
  const imagess2 = getimagess(membership?.membership_packs?.background);

  const EventCard = ({ item }) => (
    <div
      onClick={() => handleEventClick(item)}
      className="bg-[#f0f5ec] hover:opacity-70 shadow-[5px_3px_15px_rgba(0,0,0,0.3)] rounded-lg overflow-hidden mt-2 cursor-pointer relative"
    >
      {/* Sold Out Indicator */}
      {item.sold_out == 1 && (
        <img
          src={images.sold_out}
          alt="sold out"
          className="absolute right-0 top-0 h-[130px] w-[150px] z-10"
        />
      )}

      <div className="p-5 flex">
        {/* Event Details */}
        <div className="flex flex-col gap-3 flex-1">
          <div className="lg:font-bold font-bold lg:text-xl text-sm ">
            {item.title}
          </div>
          <p className="text-xs text-gray-600 mb-2 line-clamp-2">
            {item.details}
          </p>
          <div className="flex items-center gap-1">
            <FaLocationDot color="red" />
            <span className="text-blue-500 lg:text-sm text-[12px]">
              {item.venue}
            </span>
          </div>
        </div>

        {/* Date and Icon Section */}
        {/* Date and Icon Section */}
        <div className="flex flex-col justify-between">
          {/* Optional Image, like crown */}
          <RiVipCrownFill className="self-end" size={30} />

          {/* Date section with date first, then calendar icon */}
          <div className="flex items-end gap-3 text-2xl font-bold">
            {/* Date display comes first */}
            <div className="relative flex text-gray-700 flex-col">
              <span className="absolute text-end bottom-4 md:bottom-5 right-0 text-sm md:text-base ">
                {item.hide_date == 0 && item.date.split("-")[2]}
              </span>
              <span className="text-sm md:text-base">
                {(() => {
                  const month = item.date.split("-")[1];
                  switch (month) {
                    case "01":
                      return "JAN";
                    case "02":
                      return "FEB";
                    case "03":
                      return "MAR";
                    case "04":
                      return "APR";
                    case "05":
                      return "MAY";
                    case "06":
                      return "JUN";
                    case "07":
                      return "JUL";
                    case "08":
                      return "AUG";
                    case "09":
                      return "SEP";
                    case "10":
                      return "OCT";
                    case "11":
                      return "NOV";
                    case "12":
                      return "DEC";
                    default:
                      return "---";
                  }
                })()}
              </span>
            </div>

            <FcCalendar size={40} />
          </div>
        </div>
      </div>

      {/* Background Image Section */}
      <div
        style={{
          height: "15px",
          width: "100%",
          marginTop: "10px",
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
          backgroundImage: imagess2
            ? `url(${imagess2})`
            : `url(https://sysgtm.gtm.ma//images/packs/visitor-menu.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
    </div>
  );

  const renderEvents = () => {
    if (isEventsLoading) {
      return (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      );
    }
    const displayedEvents = showAll ? events : events?.slice(0, 3);

    return (
      <div className="lg:px-12 px-7">
        <h2 className="text-center text-xl font-semibold mb-6">
          {/* {translate("drawer.program")} */}
        </h2>

        <div className="space-y-4  gap-6">
          <div className="text-center lg:text-3xl text-2xl mb-8 font-bold">
            {language === "fr" ? "Programme 2025" : "2025 Program"}
          </div>
          {(() => {
            // if (thisMonthEvents.length > 0) {
            //   return (
            //     <>
            //       <h3 className="font-bold lg:text-2xl text-[15px] mb-4 px-4">
            //       {t("dashboard.month")}
            //       </h3>
            //       {thisMonthEvents?.map((item) => (
            //         <EventCard key={item.id} item={item} />
            //       ))}
            //     </>
            //   );
            // }
          })()}
          <h3 className="font-bold lg:text-2xl text-[15px] mb-4 px-4">
            Upcoming events
          </h3>
          {displayedEvents?.map((item) => (
            <EventCard key={item.id} item={item} />
          ))}
          {
            <div
              onClick={() => setShowAll(!showAll)}
              className="flex cursor-pointer flex-col gap-2 justify-center items-center mt-5"
            >
              {!showAll && events.length > 3 ? (
                <IoIosArrowDown size={50} />
              ) : (
                <IoIosArrowUp size={50} />
              )}

              <div className="text-[#0D70A1] text-xl font-bold">
                {!showAll && events.length > 3
                  ? `${t("twichiyat.show")}`
                  : `${t("twichiyat.hide")}`}
              </div>
            </div>
          }
        </div>

        {finishedEvents?.length > 0 && (
          <div className="mt-8 ">
            <h3 className="font-bold lg:text-2xl text-[15px] mb-4 px-4">
              {t("dashboard.already")}
            </h3>
            <div className="space-y-4">
              {finishedEvents?.map((item) => (
                <div
                  onClick={() => handleEventClick(item)}
                  className="bg-gray-200 hover:opacity-50 opacity-80 shadow-[5px_3px_15px_rgba(0,0,0,0.3)] rounded-lg overflow-hidden mt-2 cursor-pointer relative"
                >
                  {/* Sold Out Indicator */}
                  {item.sold_out == 1 && (
                    <img
                      src={images.sold_out}
                      alt="sold out"
                      className="absolute right-0 top-0 h-[130px] w-[150px] z-10"
                    />
                  )}

                  <div className="p-5 flex">
                    {/* Event Details */}
                    <div className="flex flex-col gap-3 flex-1">
                      <div className="lg:font-bold font-semibold lg:text-xl">
                        {item.title}
                      </div>
                      <p className="text-xs text-gray-600 mb-2 line-clamp-2">
                        {item.details}
                      </p>
                      <div className="flex items-center gap-1">
                        <FaLocationDot color="gray" />
                        <span className="text-gray-500 text-sm">
                          {item.venue}
                        </span>
                      </div>
                    </div>

                    {/* Date and Icon Section */}
                    {/* Date and Icon Section */}
                    <div className="flex flex-col justify-between">
                      {/* Optional Image, like crown */}
                      <RiVipCrownFill className="self-end" size={30} />

                      {/* Date section with date first, then calendar icon */}
                      <div className="flex items-end gap-3 text-2xl font-bold">
                        {/* Date display comes first */}
                        <div className="relative flex text-gray-700 flex-col">
                          <span className="absolute text-end bottom-4 md:bottom-5 right-0 text-sm md:text-base">
                            {item.hide_date == 0 && item.date.split("-")[2]}
                          </span>
                          <span className="text-sm md:text-base">
                            {(() => {
                              const month = item.date.split("-")[1];
                              switch (month) {
                                case "01":
                                  return "JAN";
                                case "02":
                                  return "FEB";
                                case "03":
                                  return "MAR";
                                case "04":
                                  return "AVR";
                                case "05":
                                  return "MAI";
                                case "06":
                                  return "JUN";
                                case "07":
                                  return "JUL";
                                case "08":
                                  return "AOU";
                                case "09":
                                  return "SEP";
                                case "10":
                                  return "OCT";
                                case "11":
                                  return "NOV";
                                case "12":
                                  return "DEC";
                                default:
                                  return "---";
                              }
                            })()}
                          </span>
                        </div>

                        {/* Calendar icon comes second */}
                        <MdCalendarMonth size={40} color="gray" />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      height: "15px",
                      width: "100%",
                      marginTop: "10px",
                      borderBottomLeftRadius: "5px",
                      borderBottomRightRadius: "5px",
                      backgroundImage: imagess2
                        ? `url(${imagess2})`
                        : `url(https://sysgtm.gtm.ma//images/packs/visitor-menu.png)`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const packGradients = {
    "non-golfer": {
      colors: ["#441903", "#FF6F3F", "#FFA47F", "#CA5730", "#442525"],
      locations: [0, 0.25, 0.5, 0.75, 1.0],
    },
    golfer: {
      colors: [
        "#884F00",
        "#8E5709",
        "#9D6B21",
        "#B68C49",
        "#D8BA80",
        "#FFEFBF",
        "#DDC28D",
        "#C19C62",
        "#A97C3F",
        "#976423",
        "#895210",
        "#824704",
        "#7F4400",
      ],
      locations: [
        0.01, 0.06, 0.15, 0.25, 0.38, 0.51, 0.58, 0.65, 0.72, 0.79, 0.86, 0.93,
        1.0,
      ],
    },
    "golfer+": {
      colors: [
        "#5C5C5C",
        "#6C6C6C",
        "#A5A5A5",
        "#BCBCBC",
        "#D6D6D6",
        "#C1C1C1",
        "#8A8A8A",
        "#474747",
      ],
      locations: [0, 0.02, 0.11, 0.15, 0.49, 0.53, 0.79, 1.0],
    },
    default: {
      colors: ["#608d40", "#608d40"],
      locations: [0, 0.5],
    },
  };

  function getGradientStyle(pack) {
    const gradientConfig = packGradients[pack] || packGradients.default;

    const colorStops = gradientConfig.colors
      ?.map(
        (color, index) => `${color} ${gradientConfig.locations[index] * 100}%`
      )
      .join(", ");

    return `linear-gradient(90deg, ${colorStops})`;
  }

  return (
    <div className="bg-white bg-opacity-[87%] h-full flex flex-col gap-4 md:gap-[0.5rem] w-full md:w-[100%] rounded-3xl shadow-custom py-6 md:py-12 mb-10 md:mb-[1rem]">
      <div className="text-center flex flex-col gap-6 md:gap-[2rem] text-xl md:text-3xl font-semibold px-4">
        <p className="text-3xl md:text-4xl font-bold  flex flex-col">
          {t("dashboard.privilege")}{" "}
          <span className="text-gtm-green text-[15px] md:text-3xl font-bold">
            {t("dashboard.reduction")}
          </span>
        </p>
        <div className="relative">
          <Swiper
            spaceBetween={10}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 3,
                spaceBetween: 15,
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              775: {
                slidesPerView: 3,
                spaceBetween: 7,
              },
              790: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 15,
              },
              1050: {
                slidesPerView: 5,
                spaceBetween: 7,
              },
              1280: {
                slidesPerView: 6,
                spaceBetween: 10,
              },
            }}
            modules={[Navigation, Pagination, Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            onSwiper={setSwiperInstance}
            className="w-full  md:w-[50vw] lg:w-[65vw]"
          >
            {discounts?.map((item) => (
              <SwiperSlide
                key={item.id}
                className=" w-auto  justify-self-center  md:p-4"
              >
                <div className="relative justify-self-center shadow-[0px_3px_15px_rgba(0,0,0,0.2)] rounded-full bg-white p-3 md:p-4 lg:h-[120px] lg:w-[120px] custom5:w-[140px] custom5:h-[140px] w-[100px] h-[100px]  md:h-[100px] md:w-[100px] ">
                  <img
                    src={item.logo}
                    alt="Partner Logo"
                    className="h-full rounded-lg w-full object-contain"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Conditional Rendering Logic (unchanged) */}
      {!user ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      ) : (
        <>
          {user?.membership?.membership_packs ? (
            renderEvents()
          ) : user?.free_pack === 1 ? (
            renderEvents()
          ) : (
            <div className="px-4 flex flex-col justify-center gap-4 md:gap-[2rem] items-center mt- md:px-[10rem]">
              <div className="flex flex-col gap-4 md:gap-[2rem] items-center justify-center text-center">
                <div className="text-xl md:text-3xl">
                  <p>
                    {t("dashboard.welcome")}{" "}
                    <strong>
                      {user?.nom} {user?.prenom}
                    </strong>{" "}
                    <br />
                    {t("dashboard.community")}
                  </p>
                </div>
                <div className="text-sm md:text-base w-full md:w-[100%] flex flex-col gap-2 md:gap-4 leading-relaxed md:leading-loose">
                  <span>{t("dashboard.glad_to_have")}</span>
                  <span>{t("dashboard.commitment")}</span>
                  <span>{t("dashboard.need_help")}</span>
                  <span className="font-bold md:text-lg mt-2">
                    {t("dashboard.welcome_family")}
                  </span>
                </div>
                <NavLink
                  to="/membership/demande"
                  className="text-white mt-5 text-center font-bold shadow-button hover:opacity-70 bg-gtm-green p-2 px-8 md:p-3 md:px-[3rem] rounded-3xl text-sm md:text-base"
                >
                  {t("dashboard.membership_request")}
                </NavLink>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
